import { RETRIEVE_COUNTRIES, SET_COUNTRIES_INFO } from "../actions/countries";
import { AnyAction } from "redux";
import { Reducer } from "react";
import { CountriesModel } from "@app/redux/models";

const initialState: CountriesModel = {
    data: [],
    numberOfRecords: 0,
};

const countriesReducer: Reducer<CountriesModel, AnyAction> = (
    state = initialState,
    action: AnyAction
) => {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_COUNTRIES:
            return {
                data: payload.data,
                numberOfRecords: payload.data.total_records_available,
            };
        case SET_COUNTRIES_INFO:
            return {
                ...state,
                data: payload,
            };
        default:
            return state;
    }
};

export default countriesReducer;
